import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'cancel-membership',
		path: '/account_settings/cancel_membership',
		component: loadable(
			async () => import(/* webpackChunkName: "pages/accountSettings_cancel_membership" */ './index'),
			{
				exportName: 'CancelMembership',
				fallback: Loading,
			},
		),
		frame: true,
		ssr: {
			enabled: true,
			seo: false,
		},
	},
];
